module.exports = __webpack_public_path__ + "static/media/partialpage.8b33b79c.gif";


/*****************
 ** WEBPACK FOOTER
 ** ./src/icons/partialpage.gif
 ** module id = 363
 ** module chunks = 0
 **/